<template>
  <div id="RemoteHands">
    <div class="thred">
      <MyHeaderPage
        :title="$t('help.detailTitle', { ticket_id: incident.ticketNumber })"
      />
      <TicketsBackLink />
      <div class="contentFormTwoCol" v-if="Object.keys(incident).length > 0">
        <HelpRequestDetailBox :ticket="incident">
          <template
            #colocation-category
            v-if="incident.cf_list?.cf_incident_category"
          >
            <div class="mdl-cell mdl-cell--2-col">
              <img
                src="@/assets/img/icon_package.png"
                alt="operation"
                width="45"
              />
            </div>
            <div class="mdl-cell mdl-cell--10-col">
              <div>
                <span class="label">{{ $t("help.incident.category") }}</span>
                <span class="text" style="margin-left: 3px">{{
                  incident.cf_list.cf_incident_category
                }}</span>
              </div>
            </div>
            <div class="mdl-cell mdl-cell--12-col">
              <hr />
            </div> </template
        ></HelpRequestDetailBox>
        <div class="contentSecondary noPadding minHeightThreads">
          <Threads
            :headers="headerThread"
            :ticket="incident"
            :threads="threads"
            :attachs="attachs"
            @update="getThreads"
          />
        </div>
      </div>

      <MyLoading :viewLoader="viewLoader" type="full" />
    </div>
  </div>
</template>

<script>
import Threads from "@/components/Threads.vue";
import MyLoading from "@/components/MyLoading.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import HelpRequestDetailBox from "@/components/Help/HelpRequestDetailBox";
import TicketsBackLink from "@/components/Tickets/BackLink.vue";
import { useUserStore } from "@/stores/UserStore";
import "@/assets/scss/Solutions.scss";

export default {
  name: "IncidentDetail",
  components: {
    Threads,
    MyHeaderPage,
    MyLoading,
    TicketsBackLink,
    HelpRequestDetailBox,
  },
  data() {
    return {
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      incident: {},
      threads: {},
      attachs: {},
      headerThread: {
        createdTime: "###",
        modifiedTime: "###",
      },
      viewLoader: true,
      viewError: false,
      userStore: {},
    };
  },
  methods: {
    getEntity(entityId) {
      this.viewLoader = false;
      const URL = `tickets/v1/ticket/?ticket_id=${this.$route.params.id}&ticket_type=Incident`;

      if (entityId) {
        this.axios
          .get(window.VUE_APP_MISTRA_URL + URL, {
            headers: this.he,
          })
          .then((response) => {
            this.incident = response.data.res;
            for (const [key, value] of Object.entries(this.incident)) {
              if (
                Object.prototype.hasOwnProperty.call(this.headerThread, key)
              ) {
                this.headerThread[key] = value;
              }
            }
            if (response.data) {
              this.incident = response.data.res;
            }
          })
          .then(() => {
            this.viewLoader = true;
            this.getThreads();
          })
          .catch(function (err) {
            self.viewSubmit = true;
            self.viewError = true;
            self.messageError = err.response.data.message;
          });
      }
    },
    getThreads() {
      this.axios
        .get(
          
          window.VUE_APP_MISTRA_URL +
            "tickets/v1/ticket-threads-by-ticket-number/?ticket_number=" +
            this.$route.params.id,
          { headers: this.he }
        )
        .then((response) => {
          this.threads = response.data;
          if (response.data.threadAttachments) {
            this.attachs = response.data.threadAttachments;
          }
          this.viewLoader = true;
        });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getEntity(this.$route.params.id);
    this.userStore = useUserStore();
  },
  beforeUpdate() {
    this.$IsLoggedIn();
  },
};
</script>
